import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { AccessManagementConfiguration } from './access-management-configuration';

@Injectable({
  providedIn: 'root'
})
export class AccessManagementModalService extends BaseModalService<AccessManagementConfiguration> {}
